import React, { useMemo, useEffect, useRef, useState, useCallback } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { BottomNavigator } from "@ann/web-components";
import { CreateRoleContainer, BottomNavigatorWrapper } from "./CreateRole.styled";
import { Header } from "./components";
import { CreationType, Details } from "./pages";

const CreateRole = ({ breadcrumbHelpers }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const detailsRef = useRef(null);
  const [detailsFormState, setDetailsFormState] = useState({
    canSubmit: false,
    isSubmitting: false,
  });
  const [selectedRole, setSelectedRole] = useState(null);

  useEffect(() => {
    breadcrumbHelpers?.setPageBreadcrumb?.("Roles", "Create Roles", {
      pageHref: "/v2/user-management/roles",
      subHref: "/v2/user-management/create-role",
    });
  }, [breadcrumbHelpers]);

  const isCreationTypeStep = useMemo(() => {
    const path = location.pathname;
    return path === "/v2/user-management/create-role" || path.endsWith("create-role/") || path.includes("creation-type");
  }, [location.pathname]);

  const isDetailsStep = useMemo(() => {
    const path = location.pathname;
    return path.includes("details");
  }, [location.pathname]);

  const handleFormStateChange = useCallback((state) => {
    setDetailsFormState(state);
  }, []);

  const disabledNext = useMemo(() => {
    if (isDetailsStep) {
      return !detailsFormState.canSubmit || detailsFormState.isSubmitting;
    }
    return false;
  }, [isDetailsStep, detailsFormState]);

  const navigationConfig = useMemo(() => {
    if (isCreationTypeStep) {
      return {
        backLabel: "User Management",
        nextLabel: "Details",
        nextIcon: "arrowRight",
        onBack: () => navigate("/v2/user-management"),
        onNext: () => navigate("/v2/user-management/create-role/details"),
      };
    } else if (isDetailsStep) {
      return {
        backLabel: "Creation Type",
        nextLabel: detailsFormState.isSubmitting ? "Creating..." : "Create",
        nextIcon: "arrowRight",
        onBack: () => navigate("/v2/user-management/create-role"),
        onNext: () => {
          if (detailsRef.current?.handleSubmit) {
            detailsRef.current.handleSubmit();
          }
        },
      };
    }

    return {
      backLabel: "Back",
      nextLabel: "Next",
      nextIcon: "arrowRight",
      onBack: () => navigate("/v2/user-management"),
      onNext: () => {},
    };
  }, [location.pathname, navigate, isCreationTypeStep, isDetailsStep, detailsFormState.isSubmitting]);

  return (
    <CreateRoleContainer>
      <Header />
      <Routes>
        <Route path="details" element={<Details ref={detailsRef} onFormStateChange={handleFormStateChange} selectedRole={selectedRole} />} />
        <Route index element={<CreationType onRoleSelect={setSelectedRole} />} />
      </Routes>
      <BottomNavigatorWrapper>
        <BottomNavigator
          backIcon="arrowLeft"
          backLabel={navigationConfig.backLabel}
          nextIcon={navigationConfig.nextIcon}
          nextLabel={navigationConfig.nextLabel}
          onBack={navigationConfig.onBack}
          onNext={navigationConfig.onNext}
          disabledNext={disabledNext}
        />
      </BottomNavigatorWrapper>
    </CreateRoleContainer>
  );
};

export default CreateRole;

